module.exports = "/images/3_1d42c2.png";